export enum AttendanceTypeEnum {
    IN = 'In',
    OUT = 'Out'
}
